import { useState } from "react"
import { CarRank } from "../../../../components/stats/carRank/CarRank"
import { translations } from "../../../../configs/translations"
import { Language } from "../../../../context/LanguageContext"
import { LeaderBoardPlayer } from "../../../../models/LeaderBoardPlayer"
import { getTimeFormated } from "../../../../utils/getTimeFormated"
import "./Leaderboard.css"

export interface LeaderboardProps {
    mapName: string;
    players: LeaderBoardPlayer[];
    isContinued: boolean;
    setIsContinued: (isContinued: boolean) => void;
}

export const Leaderboard = (props: LeaderboardProps) => {
    const [language, setLanguage] = useState<Language>('ru');
    const t = translations[language];

    const [isContinuedLocal, setIsContinuedLocal] = useState<boolean>(props.isContinued);
    
    // Use mock data if no players are provided
    const displayPlayers = props.players;

    return (
        <div className={isContinuedLocal ? "leaderboard-container board-show-out" : "leaderboard-container"}>
            <div className="table-container">
                <div className='table-title'>
                    <h2 className="table-title-text">{props.mapName}</h2>
                </div>

                <div className='table-wrapper'>
                    <table className="leaderboard">
                        <thead className="leaderboard-header">
                            <tr className="leaderboard-header-row">
                                <th className="leaderboard-header-cell">{t.place}</th>
                                <th className="leaderboard-header-cell"></th>
                                <th className="leaderboard-header-cell">{t.driver}</th>
                                <th className="leaderboard-header-cell">{t.car}</th>
                                <th className="leaderboard-header-cell">{t.rank}</th>
                                <th className="leaderboard-header-cell">{t.best_lap}</th>
                                <th className="leaderboard-header-cell">{t.time}</th>
                            </tr>
                        </thead>
                        <tbody className="leaderboard-body">
                            {
                                displayPlayers.map((player, index) => (
                                    <tr key={index} className={player.isGhost ? "leaderboard-row ghost-row" : "leaderboard-row"}>
                                        <td className="leaderboard-cell">{player.place}</td>
                                        <td className="leaderboard-cell">
                                            {
                                                player.isFinished &&
                                                <img className="finish-img" src='../icons/finish.png' alt="Finished"></img>
                                            }
                                        </td>
                                        <td className="leaderboard-cell">{player.isGhost && "👻 "}{player.driver}</td>
                                        <td className="leaderboard-cell">{player.car}</td>
                                        <td className="leaderboard-cell">
                                            <div className="car-rank-container">
                                                <CarRank rank={player.rank} />
                                            </div>
                                        </td>
                                        <td className="leaderboard-cell">{
                                            getTimeFormated(
                                                player.bestLap.hours,
                                                player.bestLap.minutes,
                                                player.bestLap.seconds
                                            )
                                        }</td>
                                        <td className="leaderboard-cell">{
                                            getTimeFormated(
                                                player.time.hours,
                                                player.time.minutes,
                                                player.time.seconds
                                            )
                                        }</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>

                <div className="continue-button-container" 
                    onClick={() => {
                        setIsContinuedLocal(true);
                        props.setIsContinued(true);
                    }}>
                    <div className="continue-button">{t.continue}</div>
                </div>
            </div>
        </div>
    );
}